





















































































































































import {
  defineComponent,
  PropType,
  ref,
  watch,
  computed,
  Ref,
} from '@vue/composition-api';
import {
  DictionaryForm,
  FormSpelling,
  SearchSpellingResultRow,
} from '@oare/types';
import SpellingDialog from './components/SpellingDialog.vue';
import InsertDiscourseRows from './components/InsertDiscourseRows.vue';
import { spellingHtmlReading } from '@oare/oare';
import { DataTableHeader } from 'vuetify';
import utils from '@/utils';
import sl from '@/serviceLocator';
import WordGrammar from '@/views/DictionaryWord/components/WordInfo/components/WordGrammar/WordGrammar.vue';

export default defineComponent({
  name: 'EditWordDialog',
  components: {
    SpellingDialog,
    InsertDiscourseRows,
    WordGrammar,
  },
  props: {
    form: {
      type: Object as PropType<DictionaryForm>,
      required: true,
    },
    spelling: {
      type: Object as PropType<FormSpelling | null>,
      default: null,
    },
    allowDiscourseMode: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const _ = sl.get('lodash');
    const store = sl.get('store');

    const spellingInput = ref(props.spelling ? props.spelling.spelling : '');

    const inDiscourseMode = ref(false);
    const searchSpellingLoading = ref(false);

    const canInsertDiscourseRows = computed(() =>
      store.hasPermission('INSERT_DISCOURSE_ROWS')
    );

    const spellingSearchResults: Ref<SearchSpellingResultRow[]> = ref([]);
    const spellingResultHeaders: Ref<DataTableHeader[]> = ref([
      {
        text: 'Word',
        value: 'word',
      },
      {
        text: 'Form',
        value: 'form',
      },
    ]);

    const searchSpellings = async (newSpelling: string) => {
      try {
        searchSpellingLoading.value = true;
        spellingSearchResults.value = await server.searchSpellings(newSpelling);
      } catch (err) {
        actions.showErrorSnackbar(
          'Failed to search for spellings',
          err as Error
        );
      } finally {
        searchSpellingLoading.value = false;
      }
    };

    const spellingTitle = computed(() => {
      if (props.spelling) {
        return 'Editing existing spelling';
      }
      const grammarString = utils.formGrammarString(props.form);
      return (
        `Add Spelling to ${props.form.form}` +
        (grammarString ? ` (${grammarString})` : '')
      );
    });

    watch(
      () => context.attrs.value,
      open => {
        if (!open) {
          if (props.spelling) {
            spellingInput.value = props.spelling.spelling;
          } else {
            spellingInput.value = '';
          }
          spellingSearchResults.value = [];
        } else {
          if (props.spelling) {
            searchSpellings(spellingInput.value);
          }
        }
      },
      { immediate: true }
    );

    watch(
      spellingInput,
      _.debounce(async (newSpelling: string) => {
        if (newSpelling) {
          await searchSpellings(newSpelling);
        } else {
          spellingSearchResults.value = [];
        }
      }, 500)
    );

    watch(
      () => props.allowDiscourseMode,
      () => {
        if (!props.allowDiscourseMode) {
          inDiscourseMode.value = false;
        }
      }
    );

    const selectedFormUuid = ref<string>(props.form.uuid);
    const selectForm = (form: DictionaryForm) => {
      context.emit('select-form', form);
    };

    return {
      spellingInput,
      spellingHtmlReading,
      inDiscourseMode,
      SpellingDialog,
      spellingTitle,
      formGrammarString: utils.formGrammarString,
      spellingResultHeaders,
      searchSpellingLoading,
      spellingSearchResults,
      canInsertDiscourseRows,
      selectedFormUuid,
      selectForm,
    };
  },
});
